export const Pink = {
  id: 23,
  height: 5029310,
  data: {
    icon: "/imgs/icons/asset/pink.webp",
  },
};
